export default function Profile() {
    return (
        <div>
            <h1>profile</h1>
            <h6>user\Profile.jsx</h6>
        </div>
    )
}